var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38916 4.33333V4.48333H1.53916H12.3133H12.4633V4.33333V1.44444V1.29444H12.3133H1.53916H1.38916V1.44444V4.33333ZM1.53916 0.15H12.3133C12.6847 0.15 13.0391 0.288545 13.299 0.532446C13.5586 0.776044 13.7025 1.10432 13.7025 1.44444V4.33333C13.7025 4.67346 13.5586 5.00173 13.299 5.24533C13.0391 5.48923 12.6847 5.62778 12.3133 5.62778H1.53916C1.16777 5.62778 0.813351 5.48923 0.553457 5.24533C0.293886 5.00173 0.15 4.67346 0.15 4.33333V1.44444C0.15 1.10432 0.293886 0.776044 0.553457 0.532446C0.813351 0.288545 1.16777 0.15 1.53916 0.15Z",
    fill: "#313131",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38916 11.5556V11.7056H1.53916H6.15665H6.30665V11.5556V7.94444V7.79444H6.15665H1.53916H1.38916V7.94444V11.5556ZM1.53916 6.65H6.15665C6.52804 6.65 6.88246 6.78855 7.14235 7.03245C7.40193 7.27604 7.54581 7.60432 7.54581 7.94444V11.5556C7.54581 11.8957 7.40193 12.224 7.14235 12.4676C6.88246 12.7115 6.52804 12.85 6.15665 12.85H1.53916C1.16777 12.85 0.813351 12.7115 0.553457 12.4676C0.293886 12.224 0.15 11.8957 0.15 11.5556V7.94444C0.15 7.60432 0.293886 7.27604 0.553457 7.03245C0.813351 6.78855 1.16777 6.65 1.53916 6.65Z",
    fill: "#313131",
    stroke: "white",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85791 11.5556V11.7056H10.0079H12.3167H12.4667V11.5556V7.94444V7.79444H12.3167H10.0079H9.85791V7.94444V11.5556ZM10.0079 6.65H12.3167C12.688 6.65 13.0425 6.78855 13.3024 7.03245C13.5619 7.27604 13.7058 7.60432 13.7058 7.94444V11.5556C13.7058 11.8957 13.5619 12.224 13.3024 12.4676C13.0425 12.7115 12.688 12.85 12.3167 12.85H10.0079C9.63652 12.85 9.2821 12.7115 9.02221 12.4676C8.76264 12.224 8.61875 11.8957 8.61875 11.5556V7.94444C8.61875 7.60432 8.76264 7.27604 9.02221 7.03245C9.2821 6.78855 9.63652 6.65 10.0079 6.65Z",
    fill: "#313131",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseTemplate);
export default __webpack_public_path__ + "static/media/choose-template.572eeef756f26c8fec344af8710304d5.svg";
export { ForwardRef as ReactComponent };